"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _listing = _interopRequireDefault(require("./models/listing"));
var _homePage = _interopRequireDefault(require("./variants/home-page"));
var _browsePage = _interopRequireDefault(require("./variants/browse-page"));
var _core = require("@emotion/core");
var _excluded = ["listings", "maxColumns"],
  _excluded2 = ["slideType"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var AllhomesPropertyOfTheWeek = _ref => {
  var allListings = _ref.listings,
    maxColumns = _ref.maxColumns,
    props = _objectWithoutProperties(_ref, _excluded);
  var slideType = props.slideType,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var listings = allListings.slice(0, maxColumns);
  switch (slideType) {
    case 'browse':
      return (0, _core.jsx)(_browsePage.default, _extends({
        listings: listings
      }, otherProps));
    case 'home':
    default:
      return (0, _core.jsx)(_homePage.default, _extends({
        listings: listings
      }, otherProps));
  }
};
AllhomesPropertyOfTheWeek.propTypes = {
  slideType: _propTypes.default.oneOf(['home', 'browse']),
  listings: _propTypes.default.arrayOf(_propTypes.default.shape(_listing.default)).isRequired,
  maxColumns: _propTypes.default.number,
  onClick: _propTypes.default.func,
  title: _propTypes.default.string
};
AllhomesPropertyOfTheWeek.defaultProps = {
  slideType: 'home',
  maxColumns: 3,
  onClick: () => {},
  title: 'Property of the Week'
};
var _default = exports.default = AllhomesPropertyOfTheWeek;